import type { QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import { CreateOrEditScriptModule } from "./CreateOrEditScriptModule";
import type { SpecificScriptModuleQueryParams } from "./CreateOrEditScriptModule";
interface ScriptModulePageProps {
    spaceId: string;
    scriptModuleId: string;
    queryParams: SpecificScriptModuleQueryParams;
    setQueryParams: QueryParamValuesSetter<SpecificScriptModuleQueryParams>;
}
export function ScriptModulePage({ spaceId, scriptModuleId, queryParams, setQueryParams }: ScriptModulePageProps) {
    return <CreateOrEditScriptModule spaceId={spaceId} scriptModuleId={scriptModuleId} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
